<template>
  <div v-if="isVisible">
    <h3
      v-if="heading"
      class="text-2xl mb-6"
    >
      {{ heading }}
    </h3>
    <transition
      enter-active-class="transition-all duration-300 ease-out"
      leave-active-class="transition-all duration-300 ease-out"
      enter-class="opacity-0 invisible"
      enter-to-class="opacity-100 visible"
      leave-class="opacity-100 visible"
      leave-to-class="opacity-0 invisible"
    >
      <div ref="rendered">
        <div
          v-if="initialCards"
          key="initialContent"
          v-start-with-html="initialCards"
          class="grid gap-6 grid-cols-2 md:grid-cols-4 mb-12"
        />
        <div
          v-else
          key="content"
          class="grid gap-6 grid-cols-2 md:grid-cols-4 mb-12"
        >
          <FacetRecipeCard
            v-for="card in store.state.relatedGridCards"
            :key="card.uid || card.kicker"
            :model="card"
            :tracking-obj="trackingObj"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import store from '@/components/facet/store'
import FacetRecipeCard from '@/components/facet/FacetRecipeCard.vue'

export default {
  components: {
    FacetRecipeCard
  },
  directives: {
    startWithHtml: {
      inserted(el, binding) {
        el.insertAdjacentHTML('afterbegin', binding.value)
      }
    }
  },
  props: {
    cards: {
      type: Array,
      default: () => []
    },
    slotContent: {
      type: String,
      default: ''
    },
    heading: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      store,
      initialCards: this.slotContent.trim()
    }
  },
  computed: {
    isVisible() {
      const { gridCards, loading, relatedGridCards } = this.store.state
      return !gridCards.length && !loading && relatedGridCards.length
    },
    trackingObj() {
      const { currentTagsAndTerms: currentFilters } = this.store.getters

      return {
        currentFilters,
        placement: 'facet overview page'
      }
    }
  },
  watch: {
    'store.state.tags': {
      handler() {
        this.initialCards = ''
      }
    },
    'store.state.searchTerms': {
      handler() {
        this.initialCards = ''
      }
    }
  },
  created() {
    this.setupInitialState()
  },
  methods: {
    setupInitialState() {
      const { cards } = this
      store.dispatch('setRelatedGridCards', cards)
    }
  }
}
</script>
